import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { LanguageResource } from "@exonn/js-sdk";

export const module: Module<LanguageResource> = {
  id: ResourceEnum.Language,
  bigIcon: <i className="icon-20-lang" />,
  smallIcon: <i className="icon-15-lang" />,
  name: (t: TFunction) => t("moduleName.languages"),

  list: {
    hideDeleteAction: (row) => row.is_default,
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
